import { render, staticRenderFns } from "./DescricaoNivelLinha.vue?vue&type=template&id=0720dff9&scoped=true"
import script from "./DescricaoNivelLinha.vue?vue&type=script&lang=js"
export * from "./DescricaoNivelLinha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0720dff9",
  null
  
)

export default component.exports